import { BooleanInput, coerceNumberProperty, NumberInput } from '@angular/cdk/coercion';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { Variable } from '@mtna/pojo-consumer-ts';
import { VariableSummary } from '@mtna/variable-service-core-ts';

import { CanLoad, CanLoadCtor, mixinLoading } from '../core/common-behaviors';

/* eslint-disable @angular-eslint/no-inputs-metadata-property */

// Boilerplate for applying mixins to RdsVariableListComponent.
class RdsVariableListBase {}
const _RdsVariableListMixinBase: CanLoadCtor = mixinLoading(RdsVariableListBase);

/**
 * Variable List Component to display variable properties.
 *
 * @author Zach Edwards <zach.edwards@mtna.us>
 */
@Component({
  selector: 'rds-c-variable-list',
  templateUrl: './variable-list.component.html',
  styleUrls: ['./variable-list.component.scss'],
  inputs: ['loading'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RdsVariableListComponent extends _RdsVariableListMixinBase implements CanLoad {
  static ngAcceptInputType_loading: BooleanInput;
  static ngAcceptInputType_debounceSearch: NumberInput;
  static ngAcceptInputType_variables: VariableSummary[] | Variable[] | null | undefined;

  /** Provides active color for selected variable  */
  @Input() activeVariable: VariableSummary | Variable | null | undefined;
  /** When a variable is clicked, user is navigated to `/baseUrl/ + variable.id`. Defaults to "/variables/" */
  @Input() baseUrl = '/variables/';

  /** Debounce for variable search */
  @Input()
  get debounceSearch(): number {
    return this._debounceSearch;
  }
  set debounceSearch(value: number) {
    this._debounceSearch = coerceNumberProperty(value);
  }
  private _debounceSearch = 500;

  /** Required variables to display */
  @Input()
  get variables(): VariableSummary[] | Variable[] {
    return this._variables;
  }
  set variables(variables: VariableSummary[] | Variable[]) {
    this._variables = variables || [];
  }
  private _variables: VariableSummary[] | Variable[] = [];

  /** Text the user wants to search for in the list of variables */
  @Output() search = new EventEmitter<string>();

  trackByFn(index: number, variable: VariableSummary | Variable) {
    if (!variable) {
      return index;
    }
    return variable.uri || variable.id;
  }

  handleSearch(text: string) {
    this.search.emit(text);
  }
}
